import { defineStore } from "pinia";
import { store } from "@/store";
import { AuthState } from "@/store/interface";
import { getAuthButtonListApi, getAuthMenuListApi } from "@/api/modules/login";
import { getFlatMenuList, getShowMenuList, getAllBreadcrumbList } from "@/utils";
import { flatMenuListGet } from "@/router/modules/routerDate";
import { CMenuList } from "@/layouts/LayoutTransverse/containermenuList";
import { TMenuList } from "@/layouts/LayoutTransverse/tenantMenuList";
import { SMenuList } from "@/layouts/LayoutTransverse/systemMenuList";
import { useUserStoreWithOut } from '@/store/modules/user'
import { resolvePrimaryRole } from "@/utils/role";

export const useAuthStore = defineStore({
  id: "geeker-auth",
  state: (): AuthState => ({
    // 按钮权限列表
    authButtonList: {},
    // 菜单权限列表
    authMenuList: [],
    // 当前页面的 router name，用来做按钮权限筛选
    routeName: ""
  }),
  getters: {
    // 按钮权限列表
    authButtonListGet: state => state.authButtonList,
    // 菜单权限列表 ==> 这里的菜单没有经过任何处理
    authMenuListGet: state => state.authMenuList,
    // 菜单权限列表 ==> 左侧菜单栏渲染，需要剔除 isHide == true
    showMenuListGet: state => getShowMenuList(flatMenuListGet),
    // 菜单权限列表 ==> 扁平化之后的一维数组菜单，主要用来添加动态路由
    flatMenuListGet: state => getFlatMenuList(state.authMenuList),
    // 递归处理后的所有面包屑导航列表
    breadcrumbListGet: state => getAllBreadcrumbList(state.authMenuList)
  },
  actions: {
    // Get AuthButtonList
    async getAuthButtonList() {
      const { data } = await getAuthButtonListApi();
      this.authButtonList = data;
    },
    // Get AuthMenuList
    async getAuthMenuList() {

      const userStore = useUserStoreWithOut()
      const primaryRole = resolvePrimaryRole(userStore.getRoles, userStore.getUser?.id)

     // const role = JSON.parse(localStorage.getItem("role"));
      console.log(userStore.getRoles, "roleMenu");
      // if (role?.includes("tadmin") == true || role?.includes("operator") == true || role?.includes("observer") == true) {
      //   if (role?.includes("admin") || role?.includes("cadmin")) {
      //     this.authMenuList = SMenuList;
      //   } else if (role?.includes("cadmin") == true && role?.includes("admin") == false) {
      //     this.authMenuList = CMenuList;
      //   } else if(role?.indexOf('tadmin') != -1 ) {
      //     this.authMenuList = TMenuList;
      //   }else{

      //   }
      // } else {
      //   this.authMenuList = SMenuList;
      // }
      if (primaryRole === "admin") {
        this.authMenuList = SMenuList;
      } else if (primaryRole === "cadmin") {
        this.authMenuList = CMenuList;
      } else if (primaryRole === "tadmin") {
        console.log("333");
        this.authMenuList = TMenuList;
      } else if (primaryRole === "business") {
        console.log("444");

        this.authMenuList = TMenuList;
      } else {
        this.authMenuList = SMenuList;
      }
    },
    // Set RouteName
    async setRouteName(name: string) {
      this.routeName = name;
    },
    updateShowMenuList() {
      this.showMenuListGet; // 手动调用 getters，确保执行
    }
  }
});

export const useAuthStoreWithOut = () => {
  return useAuthStore(store);
};
